/**
 * Trace ID Management
 *
 * Generates and maintains a request correlation ID (traceId) for the session.
 * Used by the Logger and API Client to link frontend actions with backend logs.
 */

// Simple UUID v4 generator
function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (c) => {
        const r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}

const STORAGE_KEY = 'sisumail_trace_id';

let currentTraceId = sessionStorage.getItem(STORAGE_KEY) || uuidv4();
sessionStorage.setItem(STORAGE_KEY, currentTraceId);

export function getTraceId() {
    return currentTraceId;
}

export function resetTraceId() {
    currentTraceId = uuidv4();
    sessionStorage.setItem(STORAGE_KEY, currentTraceId);
    return currentTraceId;
}
